var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#11998e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38ef7d",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 520,
    height: 320,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e6e8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 40,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#222"
  }, "Business Consulting"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 180,
    fill: "#f7f9fc",
    stroke: "#e6e8eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 140,
    width: 40,
    height: 40,
    fill: "#74c69d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 100,
    width: 40,
    height: 80,
    fill: "#52b788"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 60,
    width: 40,
    height: 120,
    fill: "#40916c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 20,
    width: 40,
    height: 160,
    fill: "#2d6a4f"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30,140 130,90 210,70 290,30",
    fill: "none",
    stroke: "#1b4332",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 40,
    rx: 6,
    fill: "#1b4332"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 25,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#fff"
  }, "Strategy"), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 0,
    width: 100,
    height: 40,
    rx: 6,
    fill: "#2d6a4f"
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 25,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#fff"
  }, "Growth"), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 0,
    width: 100,
    height: 40,
    rx: 6,
    fill: "#40916c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 25,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#fff"
  }, "Insights")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessConsulting);
export default __webpack_public_path__ + "static/media/business-consulting.5c20cbfbcff5601f2400555a0b3af745.svg";
export { ForwardRef as ReactComponent };